module.exports = __webpack_public_path__ + "img/KK64.a442ea86.png";